// This file is auto-generated by app/javascript/archipelago/generate_registry.mjs.
// Do not edit manually.

import Island1 from "../islands/ActionEditor"
import Island2 from "../islands/JsonViewer"
import Island3 from "../islands/RawDiffViewer"
import Island4 from "../islands/ReplayBodyEditor"

const registry = {
  "ActionEditor": Island1,
  "JsonViewer": Island2,
  "RawDiffViewer": Island3,
  "ReplayBodyEditor": Island4
}

export default registry
